// Generated by purs version 0.15.0
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
var enumConstructorsConstruct = function (dictIsSymbol) {
    return {
        enumConstructors: function (opts) {
            return [ new Data_Tuple.Tuple(opts.constructorTagTransform(Data_Symbol.reflectSymbol(dictIsSymbol)(Type_Proxy["Proxy"].value)), Data_Generic_Rep.NoArguments.value) ];
        }
    };
};
var enumConstructors = function (dict) {
    return dict.enumConstructors;
};
var genericUnsafeDecodeEnum = function (dictGeneric) {
    return function (dictEnumConstructors) {
        return function (opts) {
            var constructors = Foreign_Object.fromFoldable(Data_Foldable.foldableArray)(enumConstructors(dictEnumConstructors)(opts));
            return function (value) {
                var tag = Unscramble.decodeString(value);
                var v = Foreign_Object.lookup(tag)(constructors);
                if (v instanceof Data_Maybe.Nothing) {
                    return Unscramble.decodingError("Invalid enum tag value: " + Data_Show.show(Data_Show.showString)(tag));
                };
                if (v instanceof Data_Maybe.Just) {
                    return Data_Generic_Rep.to(dictGeneric)(v.value0);
                };
                throw new Error("Failed pattern match at Unscramble.Enum (line 19, column 5 - line 23, column 13): " + [ v.constructor.name ]);
            };
        };
    };
};
var enumConstructorsSum = function (dictEnumConstructors) {
    return function (dictEnumConstructors1) {
        return {
            enumConstructors: function (opts) {
                return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Generic_Rep.Inl.create))(enumConstructors(dictEnumConstructors)(opts)))(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Data_Tuple.functorTuple)(Data_Generic_Rep.Inr.create))(enumConstructors(dictEnumConstructors1)(opts)));
            }
        };
    };
};
var defaultEnumOptions = {
    constructorTagTransform: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
export {
    enumConstructors,
    genericUnsafeDecodeEnum,
    defaultEnumOptions,
    enumConstructorsConstruct,
    enumConstructorsSum
};
//# sourceMappingURL=index.js.map
